import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";

import "./ViewProjectPage.css";

const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL;

// Helper: Format date
const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const options = { year: "numeric", month: "short", day: "numeric" };
  return new Date(dateStr).toLocaleDateString(undefined, options);
};

export default function ViewProjectPage() {
  const navigate = useNavigate();
  const { id } = useParams(); // MUST match your route param name

  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchProject = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${API_BASE_URL}/projects/${id}`);
        if (res.data) setProject(res.data);
      } catch (err) {
        console.error("Failed to fetch project:", err.message);
        setError("Failed to load project data.");
      } finally {
        setLoading(false);
      }
    };

    fetchProject();
  }, [id]);

  if (loading) return <div className="view-project-page">Loading project data…</div>;
  if (error) return <div className="view-project-page view-project-error">{error}</div>;
  if (!project) return <div className="view-project-page">Project not found.</div>;

  return (
    <div className="view-project-page">
      {/* TITLE */}
      <h1 className="view-project-title">{project.title}</h1>

      {/* ACTION BUTTON */}
      <div className="view-project-actions">
        <motion.button
          className="view-project-btn"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => navigate(-1)}
        >
          &larr; Back
        </motion.button>
      </div>

      {/* CARD */}
      <div className="view-project-card">

        {/* IMAGE */}
        <div className="view-project-image-wrapper">
          <img
            src={project.image}
            alt={project.title}
            onError={(e) => {
              e.target.src =
                "https://ui-avatars.com/api/?name=Project&background=153D6F&color=fff&size=200";
            }}
          />
        </div>

        {/* BASIC INFO */}
        <p><strong>Status:</strong> {project.status}</p>
        <p>
          <strong>Budget:</strong> GHS{" "}
          {project.amountRaised.toLocaleString()} /{" "}
          {project.projectBudget.toLocaleString()}
        </p>

        {/* PROGRESS BAR */}
        <div className="view-project-progress">
          <div
            className="view-project-progress-fill"
            style={{ width: `${project.progress}%` }}
          >
            {project.progress}%
          </div>
        </div>

        <hr className="view-project-divider" />

        {/* DESCRIPTION */}
        <div className="view-project-section">
          <h3>Description</h3>
          <p>{project.description}</p>
        </div>

        {/* AUDIT INFO */}
        <div className="view-project-section">
          <h3>Audit Information</h3>
          <p><strong>Posted By:</strong> {project.postedBy}</p>
          <p><strong>Edited By:</strong> {project.editedBy || "N/A"}</p>
          <p><strong>Created:</strong> {formatDate(project.createdAt)}</p>
          <p><strong>Updated:</strong> {formatDate(project.updatedAt)}</p>
        </div>
      </div>
    </div>
  );
}
